module.exports = __webpack_public_path__ + "static/flags/BP-03f6838b6c568a98f4390169d51f2296.gif";